// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28hBI","col":"styles_col__2ZjDl"};